module.exports = __webpack_public_path__ + "img/9.5da89a53.png";